import { c as _c } from "react/compiler-runtime";
import styles from './styles.module.scss';
import { ListItem } from '../types';
type Props = {
  children?: React.ReactNode;
} & ListItem;
const DropdownTriggerContent = t0 => {
  const $ = _c(10);
  const {
    label,
    children,
    leadingIcon,
    caption
  } = t0;
  if (children) {
    return children;
  }
  let t1;
  if ($[0] !== leadingIcon) {
    t1 = leadingIcon && <div className={styles.leadingIcon}>{leadingIcon}</div>;
    $[0] = leadingIcon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <div className={styles.label}>{label}</div>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== caption) {
    t3 = caption && <div className={styles.caption}>{caption}</div>;
    $[4] = caption;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
DropdownTriggerContent.displayName = 'DropdownTriggerContent';
export default DropdownTriggerContent;